/**
*
* SelectDropDown
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';


import setLanguageContent from 'helpers/setLanguageContent';

import arrowdown from 'assets/icons/arrowdown.svg';

import IconHolder from 'components/Icons/IconHolder';
import ToolIcon from 'components/Icons/ToolIcon';


import Label from 'components/Label';


import SelectDropDownItem from './SelectDropDownItem';

import SelectDropDownWrapper from './styles/SelectDropDownWrapper';
import SelectDropDownTypesWrapper from './styles/SelectDropDownTypesWrapper';
import SelectDropDownSelected from './styles/SelectDropDownSelected';
import SelectDropDownSelectedTitle from './styles/SelectDropDownSelectedTitle';
import SelectDropDownMainWrap from './styles/SelectDropDownMainWrap';
import SelectDropDownAddOption from './styles/SelectDropDownAddOption';
import SelectDropDownWrapperLabel from './styles/SelectDropDownWrapperLabel';
import SelectDropDownError from './styles/SelectDropDownError';


class SelectDropDown extends React.PureComponent {

  constructor() {
    super();
    this.openOptions = this.openOptions.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);

    this.state = {
      showOptions: false,
    };

  }

  handleClickOutside() {

    if (this.state.showOptions) this.openOptions();
  }

  openOptions() {
    if (this.props.disabled) return;
    this.setState((state) => {
      return {
        showOptions: !state.showOptions
      };
    });
  }


  render() {

    const {
      options,
      selected,
      titleAsFont,
      labelIcon,
      isContentHidden,
      dropdownItemStyles,
      labelStyles,
      selectedStyles,
      icon,
      mainWrapStyles,
      addOption,
      addOptionOnClick,
      selectValueName,
      dropdownIconStyles,
      language,
      onChange,
      omitLowerCase,
      updateType,
      error,
      dropdownBackgroundColor
    } = this.props;

    const selectItems = [];

    if (options) {
      for (let i = 0; i < options.length; i++) {
        const thisValue = options[i].value || options[i].value === 0 ? options[i].value : options[i];
        const thisItem = (
          <SelectDropDownItem
            key={`SelectDropDown-${i}-${thisValue}`}
            onClick={this.handleChange}
            onChange={onChange}
            value={thisValue}
            titleAsFont={titleAsFont ? thisValue : ''}
            omitLowerCase={omitLowerCase}
            thisStyles={dropdownItemStyles}
            updateType={updateType}
            icon={options[i].icon}
            iconSize={options[i].iconSize}
            iconThisStyles={options[i].iconStyles}
            title={typeof options[i] === 'string' ? options[i] : setLanguageContent(options[i], selectValueName ? selectValueName : 'title', language)}
            dropdownBackgroundColor={dropdownBackgroundColor}
          />
        );
        selectItems.push(thisItem);
      }
    }

    const selectOptionsContent = this.state.showOptions ? (
      <SelectDropDownMainWrap thisStyles={mainWrapStyles}>
        <SelectDropDownTypesWrapper dropdownBackgroundColor={dropdownBackgroundColor}>
          {selectItems}
          {addOption
            ? (
              <SelectDropDownAddOption onClick={addOptionOnClick}>
                {`+${addOption}`}
              </SelectDropDownAddOption>
            )
            : ''}
        </SelectDropDownTypesWrapper>
      </SelectDropDownMainWrap>
    ) : '';


    const labelContent = this.props.hideLabel
      ? ''
      : (
        <>
          {icon
            && (
              <ToolIcon
                icon={icon.icon}
                iconSize={icon.iconSize}
                thisStyles={icon.iconStyles}
              />
            )}
          <Label
            title={this.props.label ? this.props.label : 'Select'}
            thisStyles={labelStyles}
            inline={true}
          />
        </>
      );

    const multipleContent = this.props.isMultiple && this.props.selected ? this.props.selected.map((thisItem) => {
      return thisItem;
    }) : '';

    const selectedTitle = (() => {
      if (options && options.length > 0 && (options[0].value || options[0].value === 0)) {
        if (options.length === 0) return options[0].title ? options[0].title : options[0].value;
        for (let i = 0; i < options.length; i++) {
          if (options[i].value === selected || options[i][updateType] === selected) return options[i].title ? typeof options[i].title === 'string' ? options[i].title : setLanguageContent(options[i], 'title', language) : options[i].value;
        }
      }
      if (selected && updateType) {
        for (let i = 0; i < options.length; i++) {
          if (options[i].value === selected || options[i][updateType] === selected) return options[i].title ? typeof options[i].title === 'string' ? options[i].title : setLanguageContent(options[i], 'title', language) : options[i].value;
        }
      }

      if (selected && typeof selected === 'string') return selected;

      if (selected.title) return setLanguageContent(selected, 'title', language);
      if (selected.value) return setLanguageContent(selected, 'value', language);  
      
      return '';
    })();

    const selectedContent = this.props.isMultiple ? (
      <SelectDropDownSelected
        titleAsFont={titleAsFont ? selectedTitle : ''}
        thisStyles={selectedStyles}
      >
        {selectedTitle}
      </SelectDropDownSelected>
    ) : (
      <SelectDropDownSelected thisStyles={selectedStyles}>
        {multipleContent}
        <SelectDropDownSelectedTitle
          disabled={this.props.disabled}
          titleAsFont={titleAsFont ? selected : ''}
        >
          {selectedTitle}
        </SelectDropDownSelectedTitle>
      </SelectDropDownSelected>
      );


    const errorContent = error ? <SelectDropDownError data-cypress={this.props['data-cypress']+'-SelectDropDownError'}>{error.statusText ? error.statusText : typeof thisError === 'string' ? thisError : 'Something is wrong...'} </SelectDropDownError> : '';

    return (
      <SelectDropDownWrapperLabel thisStyles={this.props.labelWrapperStyles} error={error} data-cypress={this.props['data-cypress']}>
        {labelContent}
        <SelectDropDownWrapper
          thisStyles={this.props.thisStyles}
          float={this.props.float}
          disabled={this.props.disabled}
          onClick={this.openOptions}
          error={error}
        >
          <IconHolder
            icon={labelIcon ? labelIcon : arrowdown}
            thisStylesWrapper={dropdownIconStyles ? dropdownIconStyles :{
              width: '2rem',
              height: '2rem',
              right: '1rem',
              position: 'absolute',
              'z-index': '10',
              top: 'calc(50% + 0.25rem)',
              transform: 'translateY(-50%)',
            }}
          />
          {isContentHidden ? '' : selectedContent}
          {selectOptionsContent}
        </SelectDropDownWrapper>
        {errorContent}
      </SelectDropDownWrapperLabel>


    );
  }
}

SelectDropDown.propTypes = {
  label: PropTypes.string,
  options: PropTypes.array,
  selected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]),
  onChange: PropTypes.func.isRequired,
  thisStyles: PropTypes.object,
  labelStyles: PropTypes.object,
  icon: PropTypes.object,
  selectedStyles: PropTypes.object,
  dropdownItemStyles: PropTypes.object,
  hideLabel: PropTypes.bool,
  isMultiple: PropTypes.bool,
  titleAsFont: PropTypes.bool,
  labelIcon: PropTypes.string,
  isContentHidden: PropTypes.bool,
  float: PropTypes.string,
  omitLowerCase: PropTypes.bool,
  updateType: PropTypes.string,
  mainWrapStyles: PropTypes.object,
  addOption: PropTypes.string,
  addOptionOnClick: PropTypes.func,
  disabled: PropTypes.bool,
  language: PropTypes.string,
  selectValueName: PropTypes.string,
  dropdownIconStyles: PropTypes.object,
  labelWrapperStyles: PropTypes.object
};

export default onClickOutside(SelectDropDown);
